import { render, staticRenderFns } from "./InquiryPage.vue?vue&type=template&id=1b3217f4&scoped=true"
import script from "./InquiryPage.vue?vue&type=script&lang=js"
export * from "./InquiryPage.vue?vue&type=script&lang=js"
import style0 from "./InquiryPage.vue?vue&type=style&index=0&id=1b3217f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3217f4",
  null
  
)

export default component.exports